import { useEffect, useState } from "react";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../../../theme/Component/ModalConfirm";
import { FileService } from "../../../../../../../core/services/FileService";
import { _ExportationsSupport, _NationalizationSupport } from "../../../../../../../core/services/dataBean/EntityCatalogVdos";
import { FileInput } from "../../../../../../theme/Component/FileInput";






interface Props {
    IDExportation: number;
}

export const ExportationsSupport = ({ IDExportation }: Props) => {

    const ExportationsSupport = useDataBean(_ExportationsSupport);

    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const fileService = new FileService();
    const [beneficiario, setbeneficiario] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [cronograma, setcronograma] = useState<any>({ name: 'cronograma', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: '', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [swich, setSwich] = useState<boolean>(null)



    useEffect(() => {
        getLista()

    }, [IDExportation])


    const getLista = () => {

        ExportationsSupport.instance.getExportationsSupportCatalogPorPropiedades({ State: 1, IDExportation: IDExportation }, null).then(
            (resp: any) => {
                if (resp) {
                    let tmp = resp;
                    tmp.forEach((element: any) => {
                        if (element.DataBeanProperties.MediaContext) {
                            element.DataBeanProperties.URL = ` <a href="${fileService.getUrlFile(element.DataBeanProperties.MediaContext, element.DataBeanProperties.Media)}" target='_blank'>DESCARGAR DOCUMENTO</a>`
                        } else {
                            element.DataBeanProperties.URL = "Sin Documento";
                        }
                    });
                    setLista(tmp);
                } else {
                    setLista([]);
                }

            }
        )

    }



    const create = () => {
        ExportationsSupport.setBean({
            State: 1,
            IDExportation: IDExportation,
            IDEmployee: single.getAccountID(),
            // Since: single.getCurrenDate()
        });
        setSwich(false);
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        //console.log(Project.bean);
        ExportationsSupport.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const deleteItem = () => {
        ExportationsSupport.bean.State = 2;
        //console.log(Project.bean);
        editaItem();
        setModalC({ ...modalC, "view": false });

    }




    const head = [
        { title: 'ID', property: 'IDExportationsSupport', visible: true },
        { title: 'Nombre del Archivo', property: 'FileName', visible: true },
        { title: 'Ver / Descargar Adjunto', property: 'URL', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Documentos">
            <div className="row">

                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={ExportationsSupport.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <>
                            <div className="row">
                                <div className="col-md-6">
                                    <label>Nombre del Archivo</label>
                                    <input type="text" name="FileName" className="form-control" value={ExportationsSupport.bean.FileName} onChange={ExportationsSupport.handleChange} />

                                </div>
                                <div className="col-md-6">
                                    <FileInput
                                        label='Documento Adjunto'
                                        directory='DocComercio'
                                        onCreate={({ Media, MediaContext }) => { ExportationsSupport.setBean({ ...ExportationsSupport.bean, "Media": Media, "MediaContext": MediaContext }) }}
                                    />
                                </div>
                                <div className="col-md-12">
                                    <label>Descripción</label>
                                    <textarea name="Description" className="form-control" value={ExportationsSupport.bean.Description} onChange={ExportationsSupport.handleChange} />
                                </div>

                            </div>

                        </>
                    </Modal>


                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}